import { lazy, FC } from 'react';
import { ClientSuspense } from 'dibs-elements/exports/ClientSuspense';
import { useFragment, graphql } from 'react-relay';

import { PdpSharedUrgencyLazy_buyerUrgencyInfo$key } from './__generated__/PdpSharedUrgencyLazy_buyerUrgencyInfo.graphql';

const PspSharedUrgency = lazy(
    () => import(/* webpackChunkName: "PdpSharedUrgency" */ './PdpSharedUrgency')
);

type Props = {
    buyerUrgencyInfo: PdpSharedUrgencyLazy_buyerUrgencyInfo$key;
};

const buyerUrgencyInfoFragment = graphql`
    fragment PdpSharedUrgencyLazy_buyerUrgencyInfo on BuyerUrgencyInfo {
        ...PdpSharedUrgency_buyerUrgencyInfo
    }
`;

export const PdpSharedUrgencyLazy: FC<Props> = ({ buyerUrgencyInfo: buyerUrgencyInfoRef }) => {
    const buyerUrgencyInfo = useFragment(buyerUrgencyInfoFragment, buyerUrgencyInfoRef);

    return (
        <ClientSuspense fallback={null}>
            <PspSharedUrgency buyerUrgencyInfo={buyerUrgencyInfo} />
        </ClientSuspense>
    );
};
